import { sortByKey } from "web/services/helpers"
import { FieldSelector } from "web/components/FieldSelector/FieldSelector"
import { useFields } from "web/hooks/data"

export default function TileFieldSelector({ tile, subjectType }) {
  const allFields = useFields({
    subjectType: subjectType,
    topicId: tile.topic?.id,
    includeSubjectFieldsForTopic: !!tile.topic?.id,
    includeMultipleSubjectsFields: true,
  })

  const sortedFields = sortByKey(allFields, "label")
  const fieldDefaultKeys = tile.fields.map((tf) => tf.key)

  function fieldsFilter(sortedField) {
    return !fieldDefaultKeys.includes(sortedField.key)
  }

  const potentialNewFields = sortedFields.filter((sortedField) =>
    fieldsFilter(sortedField)
  )

  async function onAddField(field) {
    const highestOrdinal =
      tile.fields.length > 0 ? tile.fields.at(-1).ordinal : 0

    await tile.update({
      overview_tile: {
        tile_fields_attributes: [
          {
            field_id: field.id,
            ordinal: highestOrdinal + 1,
          },
        ],
      },
    })
  }

  return (
    <FieldSelector
      onAddField={onAddField}
      allFields={allFields}
      potentialNewFields={potentialNewFields}
      sortedFields={sortedFields}
    />
  )
}
